// extracted by mini-css-extract-plugin
module.exports = {"section":"D3U_section__hat3D"};